import React from 'react';
import LoadingOverlay from 'react-loading-overlay';
import PropTypes from 'prop-types';
import { loaderStyle } from '../../../utils';

function Loading(props) {
  const { active } = props;
  return (
    <LoadingOverlay
      active={active}
      spinner
      text=""
      className="mainLoader"
      styles={loaderStyle}
    />
  );
}
Loading.propTypes = {
  active: PropTypes.bool.isRequired,
};

export default Loading;
